var $ = require('jquery')
$(function () {
  const chartElement = document.getElementById('js-price-summary-chart')

  if (chartElement === null) {
    return
  }

  const { labels, values, colors } = JSON.parse(chartElement.dataset.chart)

  new Chart(chartElement, {
    type: 'bar',
    data: {
      labels,
      datasets: [{
        label: '人数',
        data: values,
        backgroundColor: colors
      }]
    },
    options: {
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          display: true,
          stacked: false,
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            drawBorder: false
          },
          barPercentage: 1,
          categoryPercentage: 1,
          ticks: {
            suggestedMax: 25,
            suggestedMin: 0,
            stepSize: 300,
            lineWidth: 2,
            fontSize: 14,
            callback: function (value, index, values) {
              return value
            }
          }
        }]
      },
      legend: {
        display: false
      },
      title: {
        display: false,
        text: '総合評価'
      },
      plugins: {
        labels: {
          render: 'label',
          fontSize: 0
        }
      },
      animation: {
        duration: 0
      }
    }
  })
})
